export const CAMPAIGN_PERFORMANCE_HELP = Object.freeze({
  delivered:
    "Codes delivered through the partner request workflow. This is the baseline used for every percentage.",
  orderRedemption:
    "Codes associated with an order divided by delivered codes.",
  codeReleased:
    "All codes marked released divided by delivered codes.",
  unrealized:
    "Released codes without an associated order divided by delivered codes.",
  trueRedemption:
    "Released codes with an associated order divided by delivered codes.",
});

export const CAMPAIGN_HISTORY_HELP = Object.freeze({
  campaign: "The campaign designator and name. Select the designator to open campaign details.",
  status: "The current campaign preparation status.",
  generation: "Codes prepared compared with the quantity originally requested for generation.",
  available: "Generated codes that are currently ready to be delivered.",
  lastActivity: "The most recent recorded code activity for this campaign.",
  created: "When the campaign record was created.",
});
